import { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import $ from 'jquery';
window.jQuery = window.$ = $;
require('signalr');

const GlobalSignalRListener = ({ groupId, rootStore, action }) => {
    useEffect(() => {

        const connection = window.$.hubConnection(rootStore.application.baasic.getApiUrl() + "/signalr", {
            transport: 'webSockets'
        });
        connection.qs = { groupId: groupId };
        const hubProxy = connection.createHubProxy('notificationHub');

        hubProxy.on('ReceiveNotification', (message) => {
            action(message);
        });

        connection.start()
        .then(() => {
            sessionStorage.setItem("connectionId", connection.id);
        })

        return () => {
            connection.stop();
        };

    }, []);
    return null;
}

GlobalSignalRListener.propTypes = {
    groupId: PropTypes.string,
    rootStore: PropTypes.any,
    action: PropTypes.func,
};

export default GlobalSignalRListener;
